import React from 'react';
import {Container, Row, Button, Col, Spinner } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import * as ROUTES from '../../constants/routes';
import KeyboardBackspaceRoundedIcon from '@material-ui/icons/KeyboardBackspaceRounded';
import 'date-fns';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';

import { dateFormatUtil ,getFormattedDateTime,getFormattedDate} from '../Utilities';
import Form from 'react-bootstrap/Form';
import MaterialTable from 'material-table';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { withAuthorization } from '../Session';
import Alert from 'react-bootstrap/Alert';
import RestServices from '../services/RestServices.js';

import ViewProfileDetail from '../Profile/ViewProfileDetail';

import queryString from 'query-string';

const pageSizes = [5, 10, 25, 50, 100];
const searchBy = [
    { key: 'Name', value: 'FullName' },
    { key: 'Partner-ID', value: 'ProfileUniqeID' },
    { key: 'Store Tag', value: 'StoreTag' },
    { key: 'Phone Number', value: 'PhoneNumber' },
    
];

function getColumns() {
    let columns = [
        { title: 'Name', field: 'userName' },
        { title: 'PartnerID', field: 'ProfileUniqeID' },
        {
            title: 'Amount',
            field: 'amount',
            render: (item) => (
            <div>
            {item.type =='Credit' &&<span style={{color:"green"}}>+₹</span>}
            {item.type =='Debit' &&<span style={{color:"red"}}>-₹</span>}
            {parseFloat(item.amount).toFixed(2)}</div>),
            width: "10%"
            
        },
        { title: 'Payment Date', field: 'Date' ,render: (item) => getFormattedDateTime(item.Date)},
        { title: 'Transaction ID', field: 'orderId' },
        { title: 'Status', field: 'status' }
    ];

    return columns;
}
function getSource(item) {
    if(item['Source'].indexOf("Link")){
    return '<a>'+ item['Source']+'</a>';
    }else{
    return item['Source'];
    }
    
}


function getEarning(item) {
    if(item['type'] == 'Credit'){
    return '<span>+</span> ₹' + parseFloat(item['amount']).toFixed(2)+'';
    }else if(item['type'] == 'Debit'){
    return '<span>-</span> ₹' + parseFloat(item['amount']).toFixed(2);
    }else{
    return '₹' + parseFloat(item['amount']).toFixed(2);
    }
    
}



class PartnerWalletManagement extends React.Component {
    _isMounted = false;

    state = {
        perPage: 5,
        pageNumber: 0,
        LastDocument: false,
        FirstDocument: false,
        isLastPage:false,
        StartAt: [],
        moveTo: false,
        search_key: '',
        search_by: 'FullName',
        loading: false,
        newData:true,

        alert: 0,
        alertMessage: '',
        storeTag: '',
        backArrow: false,
        flag: 0,
        data: [],
        dataLinks: [],
        options: [],
        SelectedAccountNumber: '',
        withdrawAmount: '',
        addAmount: '',
        orderNote: '',
        remarks: '',
        Beneficiary: [],
        benfList: [],
        transactionCharges: 2.5,
        ShowFlashMessage: false,
        FlashMessage: '',
        showProfile:false,
        selectedRow: [],
    };

    dataArray = [];

    async componentDidMount() {
        this._isMounted = true;
            this.loadData();
        
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    
    async relaodData() {
        if (this._isMounted) {
            this.setState({
                loading: true
            });
        }

        if (this.state.search_by === 'PhoneNumber' && this.state.search_key) {
            var SearchKey = '+91'+this.state.search_key.substring(this.state.search_key.length - 10)
        } else {
            var SearchKey = this.state.search_key;
        }

        let bodyData = {
            search_key: SearchKey,
            search_by: this.state.search_by,
            LastDocument: this.state.LastDocument,
            FirstDocument: this.state.FirstDocument,
            StartAt: await this.getStartAt(),
            perPage: parseInt(this.state.perPage),
            moveTo: this.state.moveTo
        };

        
        await RestServices.allProfilesWallets(
            localStorage.getItem('FirebaseToken'),
            bodyData
        )
            .then((response) => response.json())
            .then(async (responseData) => {
                if (responseData.error) {
                    if (this._isMounted) {
                        this.setState({
                            loading: false,
                            alert: 1,
                            alertMessage: responseData.error
                        });
                    }
                } else {
                if(responseData.list.length>0){
                   
                    
                    

                    if (this.state.moveTo === 'Prev') {
                        var newPageNumber = this.state.pageNumber - 1;
                        var filteredArray = this.state.StartAt.filter(
                            (item) => item !== responseData.FirstDocument
                        );
                        if (filteredArray.length < 2) {
                            var filteredArray = [];
                            filteredArray.push(responseData.FirstDocument);
                        }
                    } else if (this.state.moveTo === 'Next') {
                        var newPageNumber = this.state.pageNumber + 1;
                        var filteredArray = this.state.StartAt;
                        filteredArray.push(responseData.FirstDocument);
                    } else {
                        var newPageNumber = 0;
                        var filteredArray = this.state.StartAt;
                        filteredArray.push(responseData.FirstDocument);
                    }

                    if (this._isMounted) {
                        this.setState({
                            isLastPage: responseData.list.length <parseInt(this.state.perPage) ? true:false,
                            pageNumber: newPageNumber,
                            StartAt: filteredArray,
                            LastDocument: responseData.LastDocument,
                            FirstDocument: responseData.FirstDocument,
                            data: responseData.list,
                            alert: 0,
                            loading: false,
                            newData:true
                        });
                    }
                   /*
                    var allLIstD = responseData.list;
                    var totalWL= 0
                    for(var i=0;i<allLIstD.length;i++){
                        totalWL=totalWL+parseFloat(allLIstD[].walletbalance)
                    }
                    
                    */
                    }else{
                    if (this._isMounted) {
                        this.setState({
                            isLastPage: true,
                            alert: 0,
                            loading: false,
                            newData:false
                        });
                    }
                    }
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({
                        data: [],
                        loading: false,
                        alert: 1,
                        alertMessage: err.message
                    });
                }
            });
    }

    getStartAt = () => {
        let StartAtLIst = this.state.StartAt;

        if (StartAtLIst.length > this.state.pageNumber + 1) {
            StartAtLIst.splice(StartAtLIst.length - 2, StartAtLIst.length - 1);
            if (this._isMounted) {
                this.setState({ StartAt: StartAtLIst });
            }
        }
        return StartAtLIst[this.state.pageNumber - 1];
    };

    handlePageSizeChange = (event) => {
        if (this._isMounted) {
            this.setState({
                perPage: event.target.value,
                moveTo: false,
                StartAt: [],
                pageNumber: 0
            });
            setTimeout(() => {
                this.relaodData();
            }, 500);
        }
    };

    submitSearch = () => {
        this.setState({ moveTo: false, StartAt: [], pageNumber: 0 });
        setTimeout(() => {
            this.relaodData();
        }, 500);
    };

    restSearch = () => {
        
        this.setState({
            search_key: '',
            moveTo: false,
            StartAt: [],
            pageNumber: 0,
            LastDocument:null,
            FirstDocument:null,
        });
        setTimeout(() => {
            this.relaodData();
        }, 500);
    };
    paginateNext = () => {
        
        if (this._isMounted) {
            this.setState({ moveTo: 'Next' });
            setTimeout(() => {
                this.relaodData();
            }, 500);
        }
    };

    paginatePrev = () => {
    
        if (this._isMounted) {
            this.setState({ moveTo: 'Prev' });
            setTimeout(() => {
                this.relaodData();
            }, 500);
        }
    };

    onChangeValues = (event) => {
    if(event.target.type === 'number' ){
		if (Number.isNaN(Number.parseFloat(event.target.value))) {
		}else{
		 this.setState({ [event.target.name]: parseFloat(event.target.value) });
		}
    }else{
        if (event.target.value === '')
            this.setState({ [event.target.name]: '' });
        else {
            this.setState({ [event.target.name]: event.target.value });
        }
        
    }
    };

    async loadData() {
        this.setState({ flag: 1 });
        await this.relaodData();
        if (this._isMounted) {
            this.setState({ flag: 2 });
        }
    }


    cancleAction = () => {
        this.loadData();
        if (this._isMounted) {
            this.setState({ showProfile: false });
        }
    };

    showViewProfile = (rowData) => {
        if (this._isMounted) {
            this.setState({ showProfile: true, selectedRow: rowData });
        }
    };


    render() {
        return (
            <Container>
            
                {!this.state.showProfile && (
                    <div>
                

                {this.state.flag === 1 && <Spinner animation="border" />}
                {this.state.loading && <Spinner animation="border" />}

                {this.state.alert === 1 && (
                    <Row>
                        <Col>
                            <Alert variant="danger">
                                {this.state.alertMessage}
                            </Alert>
                        </Col>
                    </Row>
                )}

                {this.state.alert === 2 && (
                    <Row>
                        <Col>
                            <Alert variant="success">
                                {this.state.alertMessage}
                            </Alert>
                        </Col>
                    </Row>
                )}

                {this.state.alert === 5 && (
                    <Row>
                        <Col>
                            <Alert variant="success">
                                {this.state.alertMessage}
                            </Alert>
                        </Col>
                    </Row>
                )}

                    <Row>   
                            <h4
                                style={{
                                    marginLeft: '1rem',
                                    marginRight: '1rem'
                                }}
                            >
                                Wallet Managemnet
                            </h4>
                        </Row>


                
                        <div>
                            <hr />
                        </div>
                        <Row style={{ justifyContent: 'right' }}>
                            <Col
                                style={{
                                    justifyContent: 'right',
                                    textAlign: 'right'
                                }}
                            >
                                <Form.Group
                                    as={Row}
                                    style={{
                                        justifyContent: 'right',
                                        marginRight: '0'
                                    }}
                                >
                                    <select
                                        className="form-control"
                                        style={{ width: 'auto' }}
                                        name="search_by"
                                        onChange={this.onChangeValues}
                                        value={this.state.search_by}
                                    >
                                        {searchBy.map((search) => (
                                            <option
                                                key={search.value}
                                                value={search.value}
                                            >
                                                Search By {search.key}
                                            </option>
                                        ))}
                                    </select>
                                    <Form.Control
                                        style={{
                                            marginLeft: '1rem',
                                            marginRight: '1rem',
                                            width: 'auto'
                                        }}
                                        placeholder="Search key"
                                        type="text"
                                        name="search_key"
                                        value={this.state.search_key}
                                        onChange={this.onChangeValues}
                                    />
                                    <Button
                                        variant="primary"
                                        onClick={this.submitSearch}
                                    >
                                        Search
                                    </Button>

                                    <Button
                                        style={{ marginLeft: '1rem' }}
                                        variant="primary"
                                        onClick={this.restSearch}
                                    >
                                        Reset
                                    </Button>
                                </Form.Group>
                            </Col>
                        </Row>
                        <MaterialTable
                            title="Partner Wallet Managemnet"
                            columns={[
                                { title: 'Name', field: 'FullName',
                                render: (row) => (
                                    <div
                                        style={{
                                            cursor: 'pointer',
                                            color: 'blue'
                                        }}
                                        onClick={(e) =>
                                            this.showViewProfile(row)
                                        }
                                    >
                                        {row.FullName}
                                    </div>
                                )
                             },
                             { title: 'Partner-ID', field: 'ProfileUniqeID',
                             render: (row) => (
                                 <div
                                     style={{
                                         cursor: 'pointer',
                                         color: 'blue'
                                     }}
                                     onClick={(e) =>
                                         this.showViewProfile(row)
                                     }
                                 >
                                     {row.ProfileUniqeID}
                                 </div>
                             ) },
                             { title: 'Phone Number', field: 'PhoneNumber' },
                             {
                                    title: 'Wallet Balance',
                                    field: 'walletbalance',
                                    render: (item) => (
                                    <div>₹ {parseFloat(item.walletbalance).toFixed(2)}</div>),
                             },
                                { title: 'Total Deposit Amount', field: 'totalCredit' 
                                ,
                                    render: (item) => (
                                    <div>₹ {parseFloat(item.totalCredit).toFixed(2)}</div>),
                                },
                                
                            ]}
                            data={this.state.newData?this.state.data:[]}
                            options={{
                                filtering: false,
                                search: false,
                                sorting: false,
                                paging: false,
                                actionsColumnIndex: -1
                            }}
                        />
                        <div>
                            <hr />
                        </div>
                        <Row className="custom_pagination">
                            {this.state.StartAt.length > 1 && (
                                <Col>
                                    <Button
                                        onClick={this.paginatePrev}
                                        variant="primary"
                                    >
                                        Prev
                                    </Button>
                                </Col>
                            )}
                            {this.state.StartAt.length < 2 && (
                                <Col>
                                    <Button variant="secondary" disabled={true}>
                                        Prev
                                    </Button>
                                </Col>
                            )}

                            <Col style={{ textAlign: 'center' }}>
                                {'Items per page:'}
                                <select
                                    className="items_per_page"
                                    onChange={this.handlePageSizeChange}
                                    value={this.state.perPage}
                                >
                                    {pageSizes.map((size) => (
                                        <option key={size} value={size}>
                                            {size}
                                        </option>
                                    ))}
                                </select>
                                Page: {this.state.StartAt.length}
                            </Col>

                            <Col style={{ textAlign: 'right' }}>
                                {this.state.isLastPage && (
                                    <Button variant="secondary" disabled={true}>
                                        Next
                                    </Button>
                                )}

                                {!this.state.isLastPage && (
                                    <Button
                                        onClick={this.paginateNext}
                                        variant="primary"
                                    >
                                        Next
                                    </Button>
                                )}
                            </Col>
                        </Row>
                    </div>
                )}

{this.state.showProfile && (
                    <div>
                        <Row>
                            <KeyboardBackspaceRoundedIcon
                                style={{ cursor: 'pointer', color: 'blue' }}
                                onClick={this.cancleAction}
                            />
                            <h4
                                style={{
                                    marginLeft: '1rem',
                                    marginRight: '1rem'
                                }}
                            >
                                Profile Details
                            </h4>
                        </Row>

                        <ViewProfileDetail
                            profileFullName={this.state.selectedRow.FullName}
                            selectedUserRole={this.state.selectedRow.userRole?this.state.selectedRow.userRole:"StoreCP"}
                            UniqeID={this.state.selectedRow.ProfileUniqeID}
                            {...this.props}
                        />
                    </div>
                )}
                
            </Container>
        );
    }
}

const condition = (authUser) => !!authUser;
export default withAuthorization(condition)(PartnerWalletManagement);
